import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from '@wegroup/design-system';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  title?: string;
  description: string;
  onClose: () => void;
  onConfirm: () => void;
}

const AreYouSureModal: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  title,
  description,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();
  const cancelRef = useRef(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title || t('Are you sure?')}
          </AlertDialogHeader>

          <AlertDialogBody>{description}</AlertDialogBody>

          <AlertDialogFooter>
            <Button
              data-test-id="ARE-YOU-SURE-MODAL_NO"
              variant="ghost"
              mr="3"
              onClick={onClose}
              ref={cancelRef}
            >
              {t('No')}
            </Button>
            <Button data-test-id="ARE-YOU-SURE-MODAL_YES" onClick={onConfirm}>
              {t('Yes')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default AreYouSureModal;
